const doc = [({"da":({"js":({"admin":({"products":({"select":({"select_product":"Vælg produkt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;